import React from 'react';
import styles from './index.module.scss';

export interface LotteryRecordListItem {
    id: string;
    title: string;
    participantText: string;
    endTimeText: string;
    resultText: string;
    resultType: 'ongoing' | 'win' | 'lose';
    tipText: string;
    coverImage?: string;
}

interface ProductListProps {
    list: LotteryRecordListItem[];
    navList?: Array<{ name: string; id: number; type: string }>;
    navCurrentIndex?: number;
    onItemClick?: (id: string) => void;
}

const ProductList: React.FC<ProductListProps> = ({ list = [], onItemClick }) => {
    return (
        <div className={styles.listWrap}>
            {list.map((item) => {
                const resultClass =
                    item.resultType === 'ongoing'
                        ? styles.resultOngoing
                        : item.resultType === 'win'
                          ? styles.resultWin
                          : styles.resultLose;

                return (
                    <div
                        key={item.id}
                        className={styles.card}
                        onClick={() => onItemClick && onItemClick(item.id)}
                    >
                        <div className={styles.main}>
                            <div
                                className={styles.cover}
                                style={item.coverImage ? { backgroundImage: `url(${item.coverImage})` } : undefined}
                            />
                            <div className={styles.info}>
                                <div className={styles.title}>{item.title}</div>
                                <div className={styles.metaRow}>
                                    <div className={styles.metaPill}>
                                        <span className={styles.metaIcon} />
                                        <span>{item.participantText}</span>
                                    </div>
                                    <div className={styles.metaPill}>
                                        <span className={styles.timeIcon} />
                                        <span>{item.endTimeText}</span>
                                    </div>
                                </div>
                                <div className={`${styles.resultButton} ${resultClass}`}>{item.resultText}</div>
                            </div>
                        </div>

                        <div className={styles.tipBar}>
                            <span className={styles.tipIcon} />
                            <div className={styles.tipText}>{item.tipText}</div>
                            <span className={styles.tipArrow} />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default ProductList;
